import { render, staticRenderFns } from "./EmpresaBlocoInformacao.vue?vue&type=template&id=2f373196&lang=pug"
import script from "./EmpresaBlocoInformacao.vue?vue&type=script&lang=js"
export * from "./EmpresaBlocoInformacao.vue?vue&type=script&lang=js"
import style0 from "./EmpresaBlocoInformacao.vue?vue&type=style&index=0&id=2f373196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports